const nameColumn = {
  size: 120,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  enableColumnFilter: true,
  filterFn: "contains",
  accessorKey: "name",
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  header: "Kit",
};

const patientColumn = {
  size: 100,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  enableColumnFilter: true,
  filterFn: "contains",
  accessorKey: "patient_info",
  filterVariant: "select",
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  header: "Paziente",
};

const orgColumn = {
  size: 80,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  enableColumnFilter: true,
  filterFn: "contains",
  accessorKey: "org_name",
  filterVariant: "select",
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  header: "Organizzazione",
};

export const getKitsColumns = ({ showOrg }) => {
  const columns = [nameColumn, patientColumn];
  if (showOrg) columns.push(orgColumn);
  return columns;
};
